export default __webpack_public_path__ + "static/media/user2.0f3c34da.png";